"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaPlaybackControls = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _video = _interopRequireDefault(require("video.js"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _SliderV = _interopRequireDefault(require("./SliderV2/SliderV2"));
var _MediaPlaybackController = require("./MediaPlaybackController.styled");
var _useCommonPageActionsApi = require("@studio/metrics/client/react/useCommonPageActionsApi");
var _MediaPlayer = require("@studio/constants/MediaPlayer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var formatTime = function formatTime() {
  var secs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var hrs = ~~(secs / 3600);
  if (hrs > 0) {
    return (0, _moment["default"])().startOf('day').seconds(secs).format('H:mm:ss');
  }
  return (0, _moment["default"])().startOf('day').seconds(secs).format('mm:ss');
};
var RestartControlIcon = /*#__PURE__*/_react["default"].memo(function RestartControlIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.StyledControlIcon, props);
});
var DurationLabel = /*#__PURE__*/_react["default"].memo(function DurationLabel(_ref) {
  var isLight = _ref.isLight,
    duration = _ref.duration;
  return /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.StyledTimeLabel, {
    isLight: isLight
  }, formatTime(duration));
});
var MediaPlaybackControls = exports.MediaPlaybackControls = function MediaPlaybackControls(_ref2) {
  var _videoJsNode$isDispos, _videoJsNode$isDispos2, _videoJsNode$paused2;
  var onSeek = _ref2.onSeek,
    onTogglePlay = _ref2.onTogglePlay,
    settings = _ref2.settings,
    type = _ref2.type,
    isLight = _ref2.isLight,
    readOnly = _ref2.readOnly;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    duration = _useState2[0],
    setDuration = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    seek = _useState4[0],
    setSeek = _useState4[1];
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    mediaPlaybackChanged = _useCommonPageActions.mediaPlaybackChanged;
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    videoJsNode = _useState6[0],
    setVideoJsNode = _useState6[1];
  var _id = settings._id,
    title = settings.title;
  var videoJsIsNotReady = !videoJsNode || ((_videoJsNode$isDispos = videoJsNode.isDisposed) === null || _videoJsNode$isDispos === void 0 ? void 0 : _videoJsNode$isDispos.call(videoJsNode));
  var startStopIcon;
  if (videoJsNode && !((_videoJsNode$isDispos2 = videoJsNode.isDisposed) !== null && _videoJsNode$isDispos2 !== void 0 && _videoJsNode$isDispos2.call(videoJsNode))) {
    var _videoJsNode$paused;
    startStopIcon = (_videoJsNode$paused = videoJsNode.paused) !== null && _videoJsNode$paused !== void 0 && _videoJsNode$paused.call(videoJsNode) ? _freeSolidSvgIcons.faPlay : _freeSolidSvgIcons.faPause;
  }
  (0, _react.useEffect)(function () {
    var player = (0, _video["default"])("media_player_".concat(_id));
    setVideoJsNode(player);
    player.ready(function () {
      player.on('canplay', function () {
        // Check if the video is already playing before calling play again
        if (player.paused() && settings.value.isPlaying) {
          player.play();
        }
      });
      player.on('loadedmetadata', function () {
        setDuration(player.duration() | 0);
      });
      player.on('durationchange', function () {
        setDuration(player.duration() | 0);
      });
      player.on('timeupdate', function () {
        setSeek(player.currentTime());
        setDuration(player.duration() | 0);
      });
    });
    return function () {
      player.off('loadedmetadata');
      player.off('durationchange');
      player.off('timeupdate');
      player.off('canplay');
    };
  }, [_id, setSeek, setDuration, settings.value.isPlaying]);
  var handleSeek = function handleSeek(seek) {
    if (videoJsIsNotReady) return;
    setSeek(seek);
    videoJsNode.currentTime(seek);
    onSeek(_id, seek);
    mediaPlaybackChanged({
      mediaAction: _MediaPlayer.MediaPlayerActions.SEEK_TO_TIME,
      seekedToTime: seek
    });
  };
  var handleTogglePlay = function handleTogglePlay() {
    if (videoJsIsNotReady) return;
    var currentTime = videoJsNode.currentTime();
    var duration = videoJsNode.duration();
    var isVideoPaused = videoJsNode.paused();
    var seek = currentTime === duration ? 0 : currentTime;
    onTogglePlay(_id, isVideoPaused ? 'play' : 'pause', seek);
    mediaPlaybackChanged({
      mediaAction: isVideoPaused ? _MediaPlayer.MediaPlayerActions.PLAY : _MediaPlayer.MediaPlayerActions.PAUSE
    });
  };
  var handleSeekToStart = (0, _react.useCallback)(function () {
    if (videoJsIsNotReady) return;
    onSeek(_id, 0);
    videoJsNode.currentTime(0);
    videoJsNode.play();
    mediaPlaybackChanged({
      mediaAction: _MediaPlayer.MediaPlayerActions.SEEK_TO_START
    });
  }, [onSeek, _id, videoJsNode, mediaPlaybackChanged, videoJsIsNotReady]);
  var getElapsed = function getElapsed() {
    return seek;
  };
  var durationLabelProps = (0, _react.useMemo)(function () {
    return {
      isLight: isLight,
      duration: duration
    };
  }, [isLight, duration]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !readOnly && /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.StyledControlIcon, {
    icon: startStopIcon,
    "data-testid": "".concat(type, "-playing-toggle"),
    onClick: handleTogglePlay,
    isLight: isLight,
    role: "button",
    "data-dd-action-name": "".concat(videoJsIsNotReady || (_videoJsNode$paused2 = videoJsNode.paused) !== null && _videoJsNode$paused2 !== void 0 && _videoJsNode$paused2.call(videoJsNode) ? 'Play' : 'Pause', " ").concat(title, " - ").concat(formatTime(duration - getElapsed()), "/").concat(formatTime(duration))
  }), !readOnly && /*#__PURE__*/_react["default"].createElement(RestartControlIcon, {
    icon: _freeSolidSvgIcons.faStepBackward,
    "data-testid": "".concat(type, "-seek-to-start"),
    onClick: handleSeekToStart,
    isLight: isLight,
    role: "button",
    "data-dd-action-name": "Restart ".concat(title)
  }), /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.LeftTimeWrapper, {
    readOnly: readOnly
  }, /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.StyledTimeLabel, {
    isLight: isLight
  }, formatTime(getElapsed()))), /*#__PURE__*/_react["default"].createElement(_SliderV["default"], {
    seek: seek,
    duration: duration,
    readOnly: readOnly,
    onSeek: handleSeek,
    onChange: function onChange() {},
    isLight: isLight
  }), /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.RightTimeWrapper, {
    isLight: isLight,
    readOnly: readOnly
  }, /*#__PURE__*/_react["default"].createElement(_MediaPlaybackController.StyledTimeLabel, {
    isLight: isLight
  }, formatTime(duration - getElapsed())), "/", /*#__PURE__*/_react["default"].createElement(DurationLabel, durationLabelProps)));
};